export function fillArray<T>(fromArray: T[], cls: { new (par: T) }): T[] {
    if (fromArray === null || fromArray === undefined) {
        return null;
    }
    return fromArray.map(el => new cls(el));
}

export function fillArrayWithCast<T, U>(
    fromArray: T[],
    originCls: { new (par: T) },
    constr: { (par: T): U }
): U[] {
    if (fromArray === null || fromArray === undefined) {
        return null;
    }
    // make sure instance of originCls
    fromArray = fromArray.map(el => new originCls(el));
    // cast
    const newArray: Array<U> = fromArray.map(el => constr(el));

    return newArray;
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/_models.helper.ts